import styled from '@emotion/styled'

import theme from 'styles/theme'

export const StyledCard = styled.div`
  background-color: ${theme.token.var('colors.green.a150')};
  border-radius: ${theme.token.var('borderRadius.big')};
  padding: 14px 18px 18px 18px;
  color: ${theme.token.var('colors.white')};
  width: 100%;

  @media (min-width: ${theme.token('breakpoints.lg')}) {
    padding: 33px 60px 60px 60px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`

export const FeaturedBundleItems = styled.div`
  width: 60%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;

  @media (min-width: ${theme.token('breakpoints.lg')}) {
    width: 50%;
  }
`
